import { createFileRoute, redirect } from '@tanstack/react-router';

// Overview replaces Your plan. Ember and old bookmarks still use this URL. Keep the query so the
// shell deep links (?reactivate, ?purchaseModal) still fire on Overview.
export const Route = createFileRoute('/_authenticated/settings/billing/your-plan')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/billing/overview', search: true, replace: true });
  },
});
